var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "main-news"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title primary--text"
  }, [_vm._v("사업소식")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7"
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%",
      "to": "/news/campaign/one-meal"
    }
  }, [_c('div', {
    staticClass: "overflow-hidden"
  }, [_c('v-img', {
    staticClass: "main-news__thumb",
    attrs: {
      "src": "/images/sub/campaign/one-meal/thumb.webp",
      "aspect-ratio": 768 / 432
    }
  })], 1), _c('div', {
    staticClass: "px-lg-16 py-lg-40"
  }, [_c('v-card-subtitle', {
    staticClass: "pt-lg-0"
  }, [_vm._v("진행중인 캠페인")]), _c('v-card-title', {
    staticClass: "pb-0 text-truncate-2"
  }, [_vm._v(" 결식우려아동 식사 공백 줄이기 캠페인 "), _c('br'), _vm._v(" '오늘 한 끼,' ")]), _c('v-card-actions', {
    staticClass: "justify-end pb-lg-0"
  }, [_c('v-btn', {
    staticClass: "px-16 px-md-24",
    attrs: {
      "color": "primary",
      "large": "",
      "rounded": "pill"
    }
  }, [_c('span', {
    staticClass: "font-size-18 font-size-md-20 text-center"
  }, [_vm._v("더 알아보기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.board1 ? _c('v-card', {
    attrs: {
      "to": `/community/${_vm.board1._id}`,
      "max-height": "194"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-img', {
    staticClass: "main-news__thumb",
    attrs: {
      "height": "100%",
      "max-width": "40%",
      "src": _vm.board1.thumb,
      "aspect-ratio": 1
    }
  }), _c('v-sheet', {
    attrs: {
      "max-width": "60%"
    }
  }, [_c('v-card-subtitle', [_vm._v("재단소식")]), _c('v-card-title', [_c('div', {
    staticClass: "text-truncate-3"
  }, [_vm._v(_vm._s(_vm.board1.subject))])])], 1)], 1)]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.board2 ? _c('v-card', {
    attrs: {
      "to": `/community/${_vm.board2._id}`,
      "max-height": "194"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-img', {
    staticClass: "main-news__thumb",
    attrs: {
      "height": "100%",
      "max-width": "40%",
      "src": _vm.board2.thumb,
      "aspect-ratio": 1
    }
  }), _c('v-sheet', {
    attrs: {
      "max-width": "60%"
    }
  }, [_c('v-card-subtitle', [_vm._v("후원자 소식")]), _c('v-card-title', [_c('div', {
    staticClass: "text-truncate-3"
  }, [_vm._v(_vm._s(_vm.board2.subject))])])], 1)], 1)]) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.board3 ? _c('v-card', {
    attrs: {
      "max-height": "194",
      "to": `/community/${_vm.board3._id}`
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-img', {
    staticClass: "main-news__thumb",
    attrs: {
      "height": "100%",
      "max-width": "40%",
      "src": _vm.board3.thumb,
      "aspect-ratio": 1
    }
  }), _c('v-sheet', {
    attrs: {
      "max-width": "60%"
    }
  }, [_c('v-card-subtitle', [_vm._v("사업기관 소식")]), _c('v-card-title', [_c('div', {
    staticClass: "text-truncate-3"
  }, [_vm._v(_vm._s(_vm.board3.subject))])])], 1)], 1)]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }